export class ControlSociedad {

    constructor(config = {}) {
        this.model = {
            id: {
                value: null,
                header: 'Código',
            },
            apellidos: {
                value: '',
                table: true,
                header: 'Apellidos:',
                maxLength: 'Máximo 300 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 300,
                min: 4,
                required: 'Campo requerido'
            },
            nombres: {
                value: '',
                table: true,
                header: 'Nombres:',
                maxLength: 'Máximo 300 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 300,
                min: 4,
                required: 'Campo requerido'
            },
            tipo_identificacion: {
                value: null,
                header: 'Tipo de identificación:',
                required: 'Seleccione alguna opción'
            },
            identificacion: {
                value: '',
                table: true,
                header: 'Número de identificación:',
                maxLength: 'Máximo 50 caracteres',
                minLength: 'Mínimo 4 caracteres',
                max: 50,
                min: 4,
                required: 'Campo requerido'
            },
            estado: {
                value: null,
                table: true,
                header: 'Estado formulario:',
                required: 'Seleccione alguna opción'
            }
        }
    }
}
